import GnbLogo from './GnbLogo';

export default GnbLogo;
